/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react';
import {
  Dimensions, Text, View, ScrollView, TouchableOpacity,
} from 'react-native';
import {
  ActivityIndicator, Button, Card, Colors, Dialog, Paragraph, Portal, Title,
} from 'react-native-paper';
import { SafeAreaView } from 'react-native-safe-area-context';
import { FontAwesome5 } from '@expo/vector-icons';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles';
import { pixelDimensions } from '../../../config/utils';
import { Header } from '../../../components/common';
import { AppButton } from '../../../components/form';
import { appColors } from '../../../assets/styles/global';
import { API } from '../../../service/api';
import { getClasses } from '../../../redux/actions/trainerActions';

const ButtonList = (props) => {
  const {
    value, selectedValue, label, isDay,
  } = props;
  const isSelected = isDay ? (value === selectedValue.value) : (value === selectedValue);
  return (
    <TouchableOpacity
      // eslint-disable-next-line no-sequences
      style={isSelected ? styles.buttonHourSelected : styles.buttonHour}
      {...props}
    >
      <Text style={styles.textButtonHour}>
        {label || value}
        {isSelected && (
          <>
            {' '}
            <FontAwesome5
              name="check"
              size={
                Dimensions.get('window').width < 800
                  ? pixelDimensions(3.25)
                  : pixelDimensions(2)
              }
            />
          </>
        )}
      </Text>
    </TouchableOpacity>
  );
};

export default function rescheduleClass({ route, navigation }) {
  const { trainerData } = useSelector((state) => state.trainer);
  const dispatch = useDispatch();
  const { id_aula } = route.params;
  const [selectedDay, setSelectedDay] = useState({});
  const [listDays, setListDays] = useState([]);
  const [listHours, setListHours] = useState([]);
  const [selectedHour, setSelectedHour] = useState(0);
  const [dayShow, setDayShow] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    generateDates();
  }, []);

  useEffect(() => {
    if (Object.keys(selectedDay).length !== 0) {
      setDayShow(false);
      setIsLoading(true);
      setSelectedHour(0);
      verifyHours();
    }
  }, [selectedDay]);
  function generateDates() {
    const thisdate = new Date();
    const nameDays = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'];
    const thisdays = [];
    for (let i = 0; i < 14;) {
      thisdate.setDate(thisdate.getDate() + 1);
      if (thisdate.getDay() > 0 && thisdate.getDay() < 6) {
        const day = thisdate.getDate().toString().padStart(2, 0);
        const month = (thisdate.getMonth() + 1).toString().padStart(2, 0);
        const year = thisdate.getFullYear();
        const dateShow = `${nameDays[thisdate.getDay()]} - ${day}/${month}/${year}`;
        const dateFormat = `${year}-${month}-${day}`;
        thisdays.push({
          label: dateShow,
          value: dateFormat,
        });
        i++;
      }
    }
    return setListDays(thisdays);
  }

  async function verifyHours() {
    const generateHours = [
      { inicio: '07:00', fim: '08:00' },
      { inicio: '08:00', fim: '09:00' },
      { inicio: '09:00', fim: '10:00' },
      { inicio: '10:00', fim: '11:00' },
      { inicio: '11:00', fim: '12:00' },
      { inicio: '12:00', fim: '13:00' },
      { inicio: '13:00', fim: '14:00' },
      { inicio: '14:00', fim: '15:00' },
      { inicio: '15:00', fim: '16:00' },
      { inicio: '16:00', fim: '17:00' },
      { inicio: '17:00', fim: '18:00' },
      { inicio: '18:00', fim: '19:00' },
      { inicio: '19:00', fim: '20:00' },

    ];

    API.post('/search/aula', {
      where: `id_profissional = "${trainerData.id_profissional}" AND data = "${selectedDay.value}"`,
    }).then((response) => {
      response.data.data.map(({ horario_inicio }) => {
        const hourExists = generateHours.findIndex((hour) => hour.inicio === horario_inicio);
        if (hourExists >= 0) {
          generateHours.splice(hourExists, 1);
        }
      });
      setListHours(generateHours);
      setIsLoading(false);
    });
  }

  function newDate() {
    setDayShow(true);
    setIsLoading(false);
    setSelectedDay({});
    setSelectedHour(0);
  }

  async function confirmNewDate() {
    await API.put(`/update/aula/${id_aula}`, {
      data: selectedDay.value,
      horario_inicio: selectedHour.value,
      horario_fim: selectedHour.label,
    });
    dispatch(getClasses(trainerData.id_profissional));
    setShowDialog(false);
    return navigation.navigate('Class Data');
  }
  const nextButton = selectedHour !== 0;
  return (
    <>
      <Portal>
        <Dialog visible={showDialog} onDismiss={() => setShowDialog(false)}>
          <Dialog.Title>Atenção</Dialog.Title>
          <Dialog.Content>
            <Paragraph>
              Você confirma o reagendamento da aula para:
              {' '}
              {selectedDay.label}
              {' '}
              as
              {' '}
              {selectedHour.value}
              {' '}
            </Paragraph>
          </Dialog.Content>
          <Dialog.Actions>
            <Button onPress={() => setShowDialog(false)}>Cancelar</Button>

            <Button onPress={() => confirmNewDate()}>Confirmar</Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
      <Header
        profilePic={trainerData.foto}
        canAlterPic="Alter Pic"
        navigation={navigation}
        userName={trainerData.nome}
      />

      <SafeAreaView style={styles.viewBase}>
        <ScrollView style={styles.scroll}>
          <Card style={styles.cardCalendar}>
            <Title style={styles.TitleCalendar}>{dayShow ? 'Selecione uma data' : `Data: ${selectedDay.label}`}</Title>
            {dayShow && (
            <View>
              {listDays.map((day, index) => (
                <ButtonList
                  key={index}
                  isDay
                  value={day.value}
                  selectedValue={selectedDay}
                  label={day.label}
                  onPress={() => setSelectedDay({
                    value: day.value,
                    label: day.label,
                  })}
                />

              ))}
            </View>
            )}
          </Card>
          {!dayShow && (
          <Card style={styles.card}>
            <View style={styles.cardCalendar}>
              <Title style={styles.TitleCalendar}>Escolha um Horário</Title>
              <View style={styles.groupButtonsHours}>
                {Object.keys(selectedDay).length > 0 ? (
                  <>
                    {isLoading ? <ActivityIndicator color={appColors.primary} size={pixelDimensions(7)} /> : (
                      <>
                        {listHours.map((hour) => (
                          <ButtonList
                            key={hour.inicio}
                            isDay
                            value={hour.inicio}
                            selectedValue={selectedHour}
                            onPress={() => setSelectedHour({
                              value: hour.inicio,
                              label: hour.fim,
                            })}
                          />
                        ))}
                      </>
                    )}

                  </>
                ) : (
                  <Text style={{ fontSize: 14 }}>Selecione uma data</Text>
                )}
              </View>
            </View>
            <Button
              mode="contained"
              style={styles.nextButton}
              onPress={() => newDate()}
            >
              Escolher outra Data
            </Button>
            <Button
              mode="contained"
              style={nextButton ? styles.nextButton : styles.nextButtonDisabled}
              disabled={!nextButton}
              onPress={() => setShowDialog(true)}
            >
              Reagendar
            </Button>
          </Card>
          )}
        </ScrollView>
        <AppButton
          size="bold"
          label="VOLTAR"
          rippleColor={Colors.white}
          style={styles.buttonBack}
          labelStyle={styles.textBack}
          onPress={() => navigation.goBack()}
        />
      </SafeAreaView>
    </>
  );
}
